export default function getProgressBarColor(percentComplete) {
    if (percentComplete >= 100) {
        return 'success';
    }
    if (percentComplete >= 50) {
        return 'info';
    }
    if (percentComplete >= 25) {
        return 'warning';
    }
    return 'danger';
}

export function makeBannerBackgroundStyle(backgroundUrl) {
    return {
        backgroundImage: `url(${backgroundUrl})`,
        backgroundPosition: 'center 10%',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
    };
}

export function applyWhiteLabelStyle(styleObject = {}) {
    const styles = [];
    Object.keys(styleObject).forEach((styleProp) => {
        if (styleObject[styleProp]) {
            styles.push([styleProp, styleObject[styleProp]]);
        }
    });
    styles.forEach(([k, v]) => {
        document.documentElement.style.setProperty(`--color-${k}`, `#${v}`);
    });
}
